$('.js-change-password').click(function(){
    let password_wrapper = $('.password_change_wrapper');
    if(password_wrapper.is(':visible')){
        $('#password_1').removeAttr('required');
        $('#password_2').removeAttr('required');
    }else{
        $('#password_1').attr('required', 'required');
        $('#password_2').attr('required', 'required');
    }
    password_wrapper.slideToggle();
})

$('.js-logout-form').submit(function(){
    if(!confirm($(this).data('confirm-text'))) {
        return false;
    }
})

$('.js-phone-input-restrictions').on('input', function() {
    let sanitizedValue = $(this).val().replace(/[^0-9-+]/g, ''); // Ponechá len čísla, zátvorky a plus
    $(this).val(sanitizedValue);
});
